import { AbstractError } from '@/domain/errors/abstract-error.js';

export class UnauthorizedError extends AbstractError {
    public readonly code = 401;
    constructor(message = 'Unauthorized', args?: string[]) {
        super(message, args);
    }
}
